import { InjectionToken } from '@angular/core';

export const UI_BACK_ICON_CLASSNAME = new InjectionToken<string>('UI_BACK_ICON_CLASSNAME');
